// Common
import { callQBookingApi } from "./common";

// Utils
import { get, post, put } from "Utils/HTTPMethods";

export const getGuestPatient = (id) =>
  callQBookingApi(get, "/guestPatient", { id });

export const createGuestPatient = (patient) =>
  callQBookingApi(post, "/guestPatient", patient);

export const updateGuestPatient = (patient) =>
  callQBookingApi(put, "/guestPatient", patient);
